<div class="row title">
  <h3>Dashboard / <span>Apartment List</span></h3>
  <p class="add" [routerLink]="['/apartment/create']" routerLinkActive='active'><i class="fa fa-plus" aria-hidden="true"></i></p>
<!-- 
 
  <input class="searchBox addCursor" id="in" #search (keyup)="0" placeholder="">
  <p class="searchIcon"><i class="fa fa-search" aria-hidden="true"></i></p> -->
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/list-apartment/list-apartment.component.html